import store from '@/store/index.js'
// Blocks users from accessing pages if not authenticated
export {isSignedIn, isSignedInAndVerified}

function isSignedIn (to, from, next) {
  if (store.getters['user/isAuthenticated']) {
    next()
  } else {
    next('/signin')
  }
}

function isSignedInAndVerified (to, from, next) {
  if (store.getters['user/isAuthenticated'] && store.getters['user/isVerified']) {
    next()
  } else {
    next('/verify') // send user to the home page if not verified
  }
}



// WEBPACK FOOTER //
// ./src/router/auth-gaurd.js